import { ComponentPropsWithRef, ElementType } from 'react';

export type MergeElementProps<T extends ElementType, P extends object = {}> = Omit<ComponentPropsWithRef<T>, keyof P> &
    P;

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
